import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from 'src/app/models';
import { ApiService } from '../../api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiKaspiPricesService {

  constructor(
    private api: ApiService
  ) { }


  /**
   * 
   * @param params 
   * @returns 
   */
  getOffers(priceId: string, params: any): Observable<Res> {

    return this.api.post('getPriceListOffers/' + priceId, params, 'private', 'integrationKaspi');
  }


  /**
   * 
   * @param params 
   * @returns 
   */
  importProducts(params: any): Observable<Res> {

    return this.api.post('importProducts', params, 'private', 'integrationKaspi');
  }


  /**
   * 
   * @returns 
   */
  createIncludingAll(): Observable<Res> {

    return this.api.get('createPriceListFromPublishedProducts', '', 'private', 'integrationKaspi');
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.api.post('priceLists', params, 'private', 'integrationKaspi');
  }


  /**
   * 
   * @param id 
   * @returns 
   */
  info(id: string): Observable<Res> {

    return this.api.get('getPriceList', id, 'private', 'integrationKaspi');
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  save(params: any): Observable<Res> {

    return this.api.post('savePriceList', params, 'private', 'integrationKaspi');
  }


  /**
   * 
   */
  delete(params: any): Observable<Res> {
    
    return this.api.post('deletePriceLists', params, 'private', 'integrationKaspi');
  }
}
